import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'bytesPipe'
})
export class BytesPipePipe implements PipeTransform {

    transform(bytes: number): string {
        if (bytes >= 1_000_000) {
            const megaBytes = (bytes / 1_000_000).toFixed(1);
            return `${megaBytes} MB`;
        }
        if (bytes >= 1_000) {
            const kiloBytes = (bytes / 1000).toFixed(1);
            return `${kiloBytes} KB`;
        }
        return `${bytes ?? 0} bytes`;
    }
}
